import {PolicyMailConfigList} from "./PolicyMailConfigList";
import {PolicyMailConfigEdit} from "./PolicyMailConfigEdit";
import {PolicyMailConfigCreate} from "./PolicyMailConfigCreate";

export default {
    list: PolicyMailConfigList,
    create: PolicyMailConfigCreate,
    edit: PolicyMailConfigEdit
};
